// Captura de foto desde la cámara del celular (o galería) y la devuelve como
// data URL JPEG comprimida (máx. 1024 px, calidad 0.7) para no enviar imágenes
// enormes. Usa <input capture> — funciona en móviles sin permisos de getUserMedia.
// Reutilizable; hoy la usa la app del repartidor (evidencia de entrega).
import { useRef, useState } from 'react';
import { Camera, X } from 'lucide-react';

export function FotoCaptura({ value, onChange, label = 'Foto' }: {
  value: string; onChange: (v: string) => void; label?: string;
}) {
  const ref = useRef<HTMLInputElement>(null);
  const [cargando, setCargando] = useState(false);

  const procesar = (file: File) => {
    setCargando(true);
    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        const max = 1024;
        const escala = Math.min(1, max / Math.max(img.width, img.height));
        const w = Math.round(img.width * escala);
        const h = Math.round(img.height * escala);
        const c = document.createElement('canvas');
        c.width = w; c.height = h;
        const ctx = c.getContext('2d');
        if (ctx) {
          ctx.drawImage(img, 0, 0, w, h);
          onChange(c.toDataURL('image/jpeg', 0.7));
        }
        setCargando(false);
      };
      img.onerror = () => setCargando(false);
      img.src = String(reader.result);
    };
    reader.onerror = () => setCargando(false);
    reader.readAsDataURL(file);
  };

  return (
    <div className="space-y-1">
      <label className="text-xs font-medium text-muted-foreground">{label}</label>
      <input ref={ref} type="file" accept="image/*" capture="environment" className="hidden"
        onChange={(e) => { const f = e.target.files?.[0]; if (f) procesar(f); e.target.value = ''; }} />
      {value ? (
        <div className="relative w-fit">
          <img src={value} alt="foto de entrega" className="max-h-40 rounded-md border" />
          <button type="button" onClick={() => onChange('')}
            className="absolute -right-2 -top-2 rounded-full bg-red-600 p-1 text-white shadow">
            <X className="h-3.5 w-3.5" />
          </button>
        </div>
      ) : (
        <button type="button" onClick={() => ref.current?.click()} disabled={cargando}
          className="flex h-24 w-full items-center justify-center gap-2 rounded-md border-2 border-dashed text-sm text-muted-foreground active:bg-accent">
          <Camera className="h-5 w-5" /> {cargando ? 'Procesando…' : 'Tomar foto'}
        </button>
      )}
    </div>
  );
}
